/* Zantronic theme scripts - vanilla JS, no dependencies */
(function () {
  'use strict';

  var money = function (cents) {
    if (window.Shopify && window.Shopify.currency) {
      return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0 }) + ' ' + window.Shopify.currency.active;
    }
    return (cents / 100).toFixed(2);
  };

  /* ---------- rotating announcement ---------- */
  document.querySelectorAll('[data-announcement]').forEach(function (el) {
    var items = JSON.parse(el.getAttribute('data-announcement') || '[]');
    if (items.length < 2) return;
    var target = el.querySelector('[data-announcement-text]');
    var i = 0;
    setInterval(function () {
      i = (i + 1) % items.length;
      target.textContent = items[i];
      target.parentElement.style.animation = 'none';
      void target.parentElement.offsetWidth;
      target.parentElement.style.animation = '';
    }, 3800);
  });

  /* ---------- drawers ---------- */
  function openDrawer(d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer(d) { d.classList.remove('is-open'); document.body.style.overflow = ''; }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) {
      var d = document.getElementById(openBtn.getAttribute('data-drawer-open'));
      if (d) { e.preventDefault(); openDrawer(d); }
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) {
      var parent = e.target.closest('.drawer');
      if (parent) closeDrawer(parent);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- hero slider ---------- */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('.hero__slide');
    var dots = hero.querySelectorAll('.hero__dot');
    if (slides.length < 2) return;
    var index = 0, timer;
    function show(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }
    function auto() { clearInterval(timer); timer = setInterval(function () { show(index + 1); }, 6000); }
    hero.querySelectorAll('[data-hero-prev]').forEach(function (b) { b.addEventListener('click', function () { show(index - 1); auto(); }); });
    hero.querySelectorAll('[data-hero-next]').forEach(function (b) { b.addEventListener('click', function () { show(index + 1); auto(); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); auto(); }); });
    show(0); auto();
  });

  /* ---------- horizontal rails ---------- */
  document.querySelectorAll('[data-rail-wrap]').forEach(function (wrap) {
    var rail = wrap.querySelector('[data-rail]');
    if (!rail) return;
    var step = function () { return Math.max(rail.clientWidth * 0.8, 260); };
    var prev = wrap.querySelector('[data-rail-prev]');
    var next = wrap.querySelector('[data-rail-next]');
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ---------- product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!track) return;
    function scrollTo(i) {
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    }
    function sync() {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { scrollTo(i); }); });
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    sync();
  });

  /* ---------- variant selection ---------- */
  document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    var variants = JSON.parse(form.querySelector('[data-variants]').textContent);
    var selects = form.querySelectorAll('[data-option-index]');
    var idInput = form.querySelector('[name="id"]');
    var priceEl = form.querySelector('[data-price]');
    var compareEl = form.querySelector('[data-compare-price]');
    var submit = form.querySelector('[data-add]');
    var galleryThumbs = document.querySelectorAll('[data-gallery-thumb]');

    function update() {
      var chosen = [];
      selects.forEach(function (s) { chosen[parseInt(s.getAttribute('data-option-index'), 10)] = s.value; });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return chosen[i] === undefined || o === chosen[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? submit.getAttribute('data-label') : submit.getAttribute('data-sold-out');
      }
      if (match.featured_image && galleryThumbs.length) {
        for (var i = 0; i < galleryThumbs.length; i++) {
          if (galleryThumbs[i].getAttribute('data-media-id') === String(match.featured_image.id)) { galleryThumbs[i].click(); break; }
        }
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var v = parseInt(input.value || '1', 10);
    v = btn.getAttribute('data-qty') === 'up' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
  });

  /* ---------- ajax add to cart + cart drawer ---------- */
  function refreshCartDrawer() {
    return fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var el = document.getElementById('cart-drawer-content');
        if (!el) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('cart-drawer-content');
        if (fresh) el.innerHTML = fresh.innerHTML;
        var countSrc = doc.querySelector('[data-cart-count]');
        document.querySelectorAll('[data-cart-count]').forEach(function (c) {
          if (countSrc) { c.textContent = countSrc.textContent; c.style.display = countSrc.textContent.trim() === '0' ? 'none' : ''; }
        });
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCartDrawer(); })
      .then(function () {
        var d = document.getElementById('cart-drawer');
        if (d) openDrawer(d);
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cart-change]');
    if (!link) return;
    e.preventDefault();
    var line = link.getAttribute('data-line');
    var qty = link.getAttribute('data-cart-change');
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        refreshCartDrawer();
      });
  });

  /* ---------- countdown timers ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) end = Date.now() + 1000 * 60 * 60 * 24;
    var out = {
      d: el.querySelector('[data-cd-days]'), h: el.querySelector('[data-cd-hours]'),
      m: el.querySelector('[data-cd-minutes]'), s: el.querySelector('[data-cd-seconds]')
    };
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var t = Math.floor(diff / 1000);
      if (out.d) out.d.textContent = pad(Math.floor(t / 86400));
      if (out.h) out.h.textContent = pad(Math.floor((t % 86400) / 3600));
      if (out.m) out.m.textContent = pad(Math.floor((t % 3600) / 60));
      if (out.s) out.s.textContent = pad(t % 60);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- collection sorting ---------- */
  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- back to top ---------- */
  var toTop = document.querySelector('.to-top');
  if (toTop) {
    window.addEventListener('scroll', function () {
      toTop.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });
    toTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }
})();
